/*
 =========================================================
 * Vue Black Dashboard - v1.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/black-dashboard
 * Copyright 2018 Creative Tim (http://www.creative-tim.com)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import VueRouter from "vue-router";
import RouterPrefetch from 'vue-router-prefetch'
import App from "./App";
// TIP: change to import router from "./router/starterRouter"; to start with a clean layout

// Vue router
import router from "./router/index";
Vue.use(VueRouter);

// Black Dashboard theme
import BlackDashboard from "./plugins/blackDashboard";
import i18n from "./i18n"
import './registerServiceWorker'
Vue.use(BlackDashboard);
Vue.use(RouterPrefetch);

// Vuetify
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
Vue.use(Vuetify)

// Vue youtube embed
import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed)


// butter cms
import Butter from 'buttercms';
const butter = Butter('e13abf1e393a7622be4fca35802a964286593305');

// Firebase
import firebase from 'firebase'
import 'firebase/firestore'
const config = {
  apiKey: "AIzaSyB2THvwEP09nlwVEREQlOQ8xKzpLnX62CI",
  authDomain: "sports-ai-a084a.firebaseapp.com",
  databaseURL: "https://sports-ai-a084a.firebaseio.com",
  projectId: "sports-ai-a084a",
  storageBucket: "sports-ai-a084a.appspot.com",
  messagingSenderId: "421618057578",
  appId: "1:421618057578:web:15a5964954427c734ea513",
  measurementId: "G-3DQP43JSGH"
};
firebase.initializeApp(config)
firebase.analytics();
const db = firebase.firestore();

export { db };

/* eslint-disable no-new */
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
